/**
 * Saúde do portfólio (0–100, maior = melhor), com as mesmas fórmulas e faixas
 * do projeto Base44.
 */

/** Faixas da saúde do portfólio, na ordem exibida no Base44. */
export const FAIXAS_SAUDE_PORTFOLIO = [
  { key: 'otimo', label: 'Ótimo (70+)', min: 70, max: null },
  { key: 'bom', label: 'Bom (50-69)', min: 50, max: 70 },
  { key: 'atencao', label: 'Atenção (30-49)', min: 30, max: 50 },
  { key: 'critico', label: 'Crítico (<30)', min: null, max: 30 },
]

const CFG_SAUDE = {
  otimo: { key: 'otimo', label: 'Ótimo', hex: '#059669' },
  bom: { key: 'bom', label: 'Bom', hex: '#0284c7' },
  atencao: { key: 'atencao', label: 'Atenção', hex: '#d59e0b' },
  critico: { key: 'critico', label: 'Crítico', hex: '#dc2626' },
}

export function classificarSaudePortfolio(nota) {
  const n = Number(nota)
  if (!Number.isFinite(n)) return null
  if (n >= 70) return 'otimo'
  if (n >= 50) return 'bom'
  if (n >= 30) return 'atencao'
  return 'critico'
}

export function cfgSaudePortfolio(chave) {
  return CFG_SAUDE[chave] || null
}

/**
 * Saúde do portfólio: 100 − média das notas de criticidade dos projetos em
 * andamento, ponderada pelo impacto estratégico (1/3/5).
 */
export function calcularSaudePortfolio(projetos = []) {
  const emAndamento = projetos.filter((p) => p.status === 'em_andamento')
  const distribuicao = { otimo: 0, bom: 0, atencao: 0, critico: 0 }
  if (!emAndamento.length) {
    return { nota: null, label: null, projetos_considerados: 0, distribuicao }
  }

  let pesoTotal = 0
  let soma = 0
  for (const p of emAndamento) {
    const impacto = Number(p.impacto_estrategico) || 1
    const notaGeral = Number(p.nota_geral) || 0
    pesoTotal += impacto
    soma += notaGeral * impacto
  }

  for (const faixa of FAIXAS_SAUDE_PORTFOLIO) {
    distribuicao[faixa.key] = emAndamento.filter((p) => {
      const n = 100 - (Number(p.nota_geral) || 0)
      return (faixa.min == null || n >= faixa.min) && (faixa.max == null || n < faixa.max)
    }).length
  }

  const nota = Math.round(100 - (pesoTotal > 0 ? soma / pesoTotal : 0))
  return {
    nota,
    label: cfgSaudePortfolio(classificarSaudePortfolio(nota))?.label || null,
    projetos_considerados: emAndamento.length,
    distribuicao,
  }
}

export function podeVerVisaoGeral({ isCriar, isAuditor, userId, projeto, pcm } = {}) {
  if (isCriar) return false
  if (isAuditor) return true
  const uid = Number(userId)
  if (!Number.isFinite(uid) || uid <= 0) return false
  if (Number(projeto?.gerente_id) === uid) return true
  if (Number(pcm?.gerentePCM_id) === uid) return true
  if (Number(projeto?.assessor_id) === uid) return true
  const comite = pcm?.comite_aprovacao
  if (Array.isArray(comite) && comite.some((m) => Number(m?.id) === uid)) return true
  return false
}

export const ABA_VISAO_GERAL = 10
export const ABA_PLANO_PROJETO = 3
export const ABA_PROPOSTA = 1

export function abaInicialProjeto({ isCriar, queryAba, visaoGeral } = {}) {
  if (isCriar) return ABA_PROPOSTA
  const fromQuery = Number(queryAba)
  if (Number.isFinite(fromQuery) && fromQuery > 0) {
    if (fromQuery === ABA_VISAO_GERAL && !visaoGeral) return ABA_PLANO_PROJETO
    return fromQuery
  }
  return visaoGeral ? ABA_VISAO_GERAL : ABA_PLANO_PROJETO
}
